export default __webpack_public_path__ + "static/media/detail_mobile_2_4.ecf8bdd2.png";